import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { changeStatus, setSearchStatus } from '../../../../../Redux/slices/globalSlice';
import GetAppointmentStatus from 'Utils/Helpers/AppointmentStatus';
import Box from '../Box';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { changeStatusStatus } from 'http/components/SettingService';

export default function ManageStatuses() {
  const dispatch = useDispatch();
  const { totalStatuses } = useSelector((state) => ({
    totalStatuses: state.setting.totalStatuses,
  }));

  const handleChangeStatus = async (event) => {
    const id = event.target.id;
    const index = +event.target.name;
    const checked = event.target.checked;
    dispatch(HandleLoading(true));
    const response = await changeStatusStatus(id, checked);
    if(response.status) {
      if(response.data.status) {
        dispatch(changeStatus({
          index, status: response.data.changeTo
        }))
      } else {
        dispatch(changeStatus({
          index, status: true
        }))
      }
      dispatch(HandleLoading(false));
    } else {
      dispatch(HandleLoading(false));
    }
  }

  useEffect(() => {
    if(totalStatuses) {
      dispatch(setSearchStatus(totalStatuses));
    }
  },[totalStatuses])

  return (
    <Box
      title={"تمامی وضعیت‌ها"}
      info={"وضعیت‌های غیر‌قابل تغییر (خاکستری رنگ) برای هر نوبت الزامی می‌باشند"}
      body={
        <div className='group-checkbox column-show'>
          {
            (totalStatuses && totalStatuses.length !== 0)
            ? totalStatuses.map((items, index) => {
              return (
                <div className='times-checkbox'>
                  <FormControlLabel
                    key={`fc-${index}`}
                    control={<Checkbox
                      name={index}
                      id={items.serverId}
                      sx={{margin: 0, padding: 0, marginLeft: '3px'}}
                      checked={items.status}
                      onChange={handleChangeStatus}
                      disabled={items.force}
                    />}
                    label={<GetAppointmentStatus id={items.id}/>}
                  />
                </div>
              )
            }) : <small className='each-status w-100 text-center mb-2'>{"وضعیتی ثبت نشده"}</small>
          }
        </div>
      }
    />
  );
}